import { render, staticRenderFns } from "./CCBDeclare.vue?vue&type=template&id=ba19984c&scoped=true&"
import script from "./CCBDeclare.vue?vue&type=script&lang=js&"
export * from "./CCBDeclare.vue?vue&type=script&lang=js&"
import style0 from "./CCBDeclare.vue?vue&type=style&index=0&id=ba19984c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba19984c",
  null
  
)

export default component.exports